import {useRequestTributum} from '@hooks'
import {API_TRIBUTUM_CLIENTE_ID} from "@constants";
import type { ClienteHttp, XmlNfeResponse } from '../types';

const BASE_URL = '/clientes/' + API_TRIBUTUM_CLIENTE_ID

// Instanciado sob demanda (e não no topo do módulo) porque @services e @hooks
// se importam em ciclo (TributumService -> @hooks -> useRequestTributum -> @services);
// chamar useRequestTributum() na primeira avaliação do módulo pode ocorrer antes
// do ciclo terminar de resolver, com useRequestTributum ainda indefinido.
// TODO: Claude 14/09/2026 | remover lazy quando useRequestTributum.ts importar getTokenFromTributum direto de ./TributumAuthService
let cliente: ClienteHttp | undefined

function obterCliente(): ClienteHttp {
    // useRequestTributum não é um hook React (não usa useState/useContext/etc.),
    // é uma fábrica que só coincide com o prefixo "use". A regra estática não
    // sabe disso e acusa chamada de hook fora de componente/hook.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    cliente ??= useRequestTributum()
    return cliente
}

async function getNfe(nfeChave: string) {
    const url = `${BASE_URL}/nfes/${nfeChave}/`;
    return obterCliente().get<XmlNfeResponse>(url);
}

export const tributumService = {
    getNfe,
}

/**
 * Adapter temporário: preserva a factory atual para os consumidores que ainda
 * não migraram para o singleton puro (Tasks 6-8 da Fase 5). Não chama hook React.
 */
export function TributumService() {
    return tributumService
}
